import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { Toaster } from "sonner";
import { store } from "./store";
import { ThemeProvider } from "./theme/ThemeProvider";
import App from "./App";
import { SessionKeepAlive } from "./auth/SessionKeepAlive";
import { SessionBootstrap } from "./auth/SessionBootstrap";
import { AccessSync } from "./auth/AccessSync";
import { TabSessionGuard } from "./auth/TabSessionGuard";
import { onTokenRefreshed } from "./auth/sessionSync";
import { tokenRefreshed } from "./auth/store/authSlice";
import "./index.css";
import { i18nReady } from "./i18n";

// Wires privateClient.ts's silent token refresh (reactive on 401, and
// proactive via SessionKeepAlive below) into Redux — see sessionSync.ts
// for why this can't just be a direct store import from privateClient.ts.
onTokenRefreshed((token) => store.dispatch(tokenRefreshed(token)));

document.addEventListener("wheel", () => {
  const el = document.activeElement;
  if (el instanceof HTMLInputElement && el.type === "number") el.blur();
}, { passive: true });

const landingChunk = location.pathname === "/" ? import("./landing/pages/LandingPage").catch(() => {}) : Promise.resolve();

Promise.all([i18nReady, landingChunk]).then(() => ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <SessionBootstrap />
        <SessionKeepAlive />
        <AccessSync />
        <TabSessionGuard />
        <App />
        <Toaster richColors position="top-right" />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
))
